import { cn } from "../../lib/utils";
import { amountRange, isPlan, rupees, type Product } from "./types";

interface ProductPriceProps {
  product: Product;
  size?: "md" | "lg";
  className?: string;
}

/** A product's price; for a credits plan, its rate per minute and the amounts it sells for. */
export function ProductPrice({ product, size = "md", className }: ProductPriceProps) {
  const big = size === "lg" ? "text-3xl" : "text-2xl";
  if (!isPlan(product)) {
    return (
      <div className={cn(big, "font-bold tabular-nums tracking-tight text-ink", className)}>{rupees(product.price)}</div>
    );
  }
  return (
    <div className={className}>
      <span className={cn(big, "font-bold tabular-nums tracking-tight text-ink")}>{rupees(product.price)}</span>
      <span className="ml-1 text-sm font-medium text-ink-3">/ min</span>
      <p className="mt-1 text-sm tabular-nums text-ink-2">{amountRange(product)}</p>
    </div>
  );
}
